import React, { useEffect } from 'react'

import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'

import Heading from '../../../components/dashboard/Heading'
import HeaderFilter from './components/HeaderFilter'
import RatingQuestionListWrapper from './components/RatingQuestionListWrapper'
import SaveRatingQuestion from './components/SaveRatingQuestion'
import UpdateRatingMatrix from './components/UpdateRatingMatrix'

import {
  fetchRatingGroupRecord,
  fetchRatingQuestionList,
  resetNotification,
} from '../../../store/actions/ratingActions'

const RatingQuestions = () => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const { addToast } = useToasts()

  const { modal, notification, selectedRecord } = useSelector(
    (state) => state.ratings
  )

  const handleFetchList = (url) => {
    dispatch(fetchRatingQuestionList(url))
  }

  useEffect(() => {
    dispatch(fetchRatingGroupRecord(`/rating-groups?id=${id}`))
  }, [])

  useEffect(() => {
    if (notification.value === 'success') {
      addToast(notification?.message, {
        appearance: 'success',
        autoDismiss: true,
      })
    }
    if (notification.value === 'error') {
      addToast(notification?.message, {
        appearance: 'error',
        autoDismiss: true,
      })
    }
    dispatch(resetNotification())
  }, [notification.value])

  return (
    <>
      <Heading
        title={`Rating Questions for ${selectedRecord?.ratingGroup?.name}`}
      />
      <HeaderFilter fetchList={handleFetchList} />

      {/* Contains list of rating questions */}
      <RatingQuestionListWrapper fetchRatingQuestionList={handleFetchList} />

      {/* Modal section */}
      {(modal === 'createRatingQuestion' ||
        modal === 'updateRatingQuestion') && <SaveRatingQuestion />}
      {modal === 'updateRatingMatrix' && <UpdateRatingMatrix />}
    </>
  )
}

export default RatingQuestions
